<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.firma"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.company") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.ansprechpartner"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.Contactperson") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="verantwortlicher"
                      :person="filters.verantwortlicher"
                      :label="$t('global.Responsible')"
                      :allowOpen="false"
                      editable
                      :rollen="filterMitarbeitende"
                      @confirmed="setVerantwortlicher"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              headline="Beratungsauftraege"
              :date="'Mittwoch 29.Juli'"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>

            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <button
                      class="btn btn-success mr-2"
                      @click="neuerLead"
                      v-if="berechtigungen.m_lead.create"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_lead.delete"
                      :disabled="isDisabled"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      <span>{{ $t("global.delete") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste belegliste-font12">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-compare="sortDates"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'kotlin-app-api')"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="leads-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Api from "@/api/Api";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";

import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import { LADE_ARTIKEL } from "@/store/artikel/actions.type";
import AppApi from "@/api/AppApi";

export default {
  name: "Beratungsauftraege",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    SingleSelectPerson,
    FilterSearchResetButton,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + "Beratungsauftraege"
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      isDisabled: false,
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        /*{
          key: "wahrscheinlichkeit",
          sortable: true,
          label: this.$t("global.stage"),
          searchable: false,
          tdClass: "text-center",
          thClass: "text-center",
          formatter: (value, key, item) => {
            if (!item.stage) return "";
            else if (item.stage.wahrscheinlichkeit)
              return numeral(item.stage.wahrscheinlichkeit / 100).format("%");
            else return item.stage.wahrscheinlichkeit == 0 ? "0%" : "";
          },
        },*/
        /*{
          key: "typ.appkey",
          label: this.$t("global.type"),
          sortable: true,
          formatter: (value) => {
            if (value) {
              return value == "leada" ? "A" : value == "leadb" ? "B" : "C";
            } else {
              return "";
            }
          },
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "umsatzbewertet",
          sortable: true,
          label: this.$t("global.sales"),
          formatter: (value) => {
            return value ? numeral(value / 1000).format("#,##0") + "K" : "";
          },
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },*/

        {
          key: "firma",
          sortable: true,
          label: this.$t("global.company"),
          searchable: true,
          formatter: (value) => {
            if (value) return value.name;
            else return "";
          },
        },
        {
          key: "ansprechpartner",
          sortable: true,
          label: this.$t("global.Contactperson"),
          searchable: true,
          formatter: (value) => {
            if (value) return value.personName;
            else return "";
          },
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
          searchable: false,
        },

        {
          key: "telefon",
          label: this.$t("global.phone"),
          searchable: false,
          formatter: (value, key, item) => {
            let phone = "";
            let scope = item.ansprechpartner;

            if (scope) {
              if (scope.telefon_m && scope.telefon_m != "") {
                phone = scope.telefon_m;
              } else if (scope.telefon_g && scope.telefon_g != "") {
                phone = scope.telefon_g;
              } else {
                phone = scope.telefon_p;
              }
            }

            return phone ? phone : "";
          },
        },

        {
          key: "noofcalls",
          label: this.$t("global.NoOfCalls"),
          searchable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "naechsterkontakt",
          label: this.$t("global.nextcontact"),
          searchable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },

        /*{
          key: "show_details",
          label: "",
          searchable: false,
        },*/
      ];
    },
    queryParams: function () {
      var params = {};

      params.typ = this.setQueryParamList(this.filters.typ?.id);
      params.art = this.setQueryParamList(this.filters.artikel?.id);
      params.f = this.setQueryParam(this.filters.firma);
      params.ap = this.setQueryParam(this.filters.ansprechpartner);
      params.ver = this.setQueryParam(this.filters.verantwortlicher?.id);

      if (this.filters.count != "") params.filterCount = this.filters.count;

      return params;
    },
    artikelListe() {
      let tempList = this.$store.state.artikel.artikel;
      return tempList.sort((a, b) =>
        a.kurzbezeichnung.localeCompare(b.kurzbezeichnung)
      );
    },
    leadstages: {
      get() {
        return this.$store.state.crm.leadstages;
      },
    },
    leadtypen: {
      get() {
        return this.$store.state.crm.leadtypen;
      },
    },
  },
  created() {
    this.initFilter("beratungsauftrag-liste", "beratungsauftrag/", true);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
    if (this.leadtypen.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    if (this.artikelListe.length == 0)
      this.$store.dispatch(`artikel/${LADE_ARTIKEL}`);
  },
  methods: {
    details(lead) {
      this.$router.push({
        name: "beratungsauftrag",
        params: { id: lead.id, anzeige: 0 },
      });
    },

    getEMail(person) {
      let email = "";

      if (person && person.mailadressen && person.mailadressen[0]) {
        let mailadressen = person.mailadressen;
        email = mailadressen[0].bezeichnung;

        for (var idx = 1; idx < mailadressen.length; idx++) {
          if (mailadressen[idx].hauptadresse)
            email = mailadressen[idx].bezeichnung;
        }
      }

      return email;
    },

    neuerLead() {
      this.$router.push({
        name: "beratungsauftrag",
        params: { anzeige: 0 },
      });
    },

    loeschen() {
      AppApi.delete("/beratungsauftrag", { data: this.selectedIds }).then((response) => {
        this.schliesseLoeschenModal();
        this.resetLoading(this)

        this.listData = this.listData.filter(
          (v) => !response.data.success.includes(v.id)
        );
      });
    },

    schliesseLoeschenModal() {
      $("#leads-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#leads-loeschen-modal").modal("show");
    },

    setVerantwortlicher(person) {
      this.$set(this.filters, "verantwortlicher", person);
    },
  },
};
</script>

<style></style>
